export const bookkeepingContact = {
  title : "contact_bookkeeping_title",
  description: "contact_bookkeeping_description"
}